import './styles.css'

function addRipple(el: HTMLElement, clientX: number, clientY: number): HTMLSpanElement {
    const rect = el.getBoundingClientRect()
    const size = Math.max(rect.width, rect.height)
    const ripple = document.createElement('span')
    ripple.className = 'ripple-wave'
    ripple.style.width = `${size}px`
    ripple.style.height = `${size}px`
    ripple.style.left = `${clientX - rect.left - size / 2}px`
    ripple.style.top = `${clientY - rect.top - size / 2}px`
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative'
    el.style.overflow = 'hidden'
    el.appendChild(ripple)
    return ripple
}

let initialized = false

export function initRipple(): void {
    if (initialized) return
    initialized = true
    document.addEventListener('click', (e: MouseEvent) => {
        if (!(e.target instanceof Element)) return
        const el = e.target.closest<HTMLElement>('[data-ripple]')
        if (!el) return
        const persist = el.dataset.ripple === 'persist'
        if (persist && el.querySelector('.ripple-wave')) return
        const ripple = addRipple(el, e.clientX, e.clientY)
        if (persist) {
            ripple.classList.add('ripple-persist')
        } else {
            ripple.addEventListener('animationend', () => ripple.remove(), { once: true })
        }
    })
}
